module.exports = __webpack_public_path__ + "static/img/Nick-Daicos.3ebda39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nick-Daicos.jpg
// module id = HH+v
// module chunks = 0